import { render, staticRenderFns } from "./baseTable.vue?vue&type=template&id=ab409174&scoped=true&"
import script from "./baseTable.vue?vue&type=script&lang=js&"
export * from "./baseTable.vue?vue&type=script&lang=js&"
import style0 from "./baseTable.vue?vue&type=style&index=0&id=ab409174&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab409174",
  null
  
)

export default component.exports